"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeDefaults = exports.COURIER_CLIENT_HEADER = void 0;
var COURIER_CLIENT_HEADER = "x-courier-client-key";
exports.COURIER_CLIENT_HEADER = COURIER_CLIENT_HEADER;
var themeDefaults = {
  colors: {
    primary: "#9121c2"
  },
  inapp: {
    toast: {
      borderRadius: "6px"
    }
  }
};
exports.themeDefaults = themeDefaults;